<div class="footer">
    <!-- Footer -->
<div class="container">
    <footer class="page-footer font-small light pt-4">

        <!-- Footer Links -->
        <div class="container-fluid text-center text-md-left">
      
          <!-- Grid row -->
          <div class="row">
      
            <!-- Grid column -->
            <div class="col-md-6 mt-md-0 mt-3">
      
              <!-- Content -->
              <h5 class="text-uppercase">Footer Content</h5>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae nobis, perspiciatis quisquam ad eum impedit. Et iste atque doloremque quo omnis architecto, asperiores repellat aut fuga quaerat at, eveniet velit.</p>
      
            </div>
            <!-- Grid column -->
      
            <hr class="clearfix w-100 d-md-none">
      
            <!-- Grid column -->
            <div class="col-md-3 mb-md-0 ">
      
              <!-- Links -->
              <h5 class="text-uppercase">Links</h5>
      
              <ul class="list-unstyled">
                <li>
                  <a href="#!">Link 1</a>
                </li>
                <li>
                  <a href="#!">Link 2</a>
                </li>
                <li>
                  <a href="#!">Link 3</a>
                </li>
                <li>
                  <a href="#!">Link 4</a>
                </li>
              </ul>
      
            </div>
            <!-- Grid column -->
      
            <!-- Grid column -->
            <div class="col-md-3 mb-md-0 mb-3">
      
              <!-- Links -->
              <h5 class="text-uppercase">Links</h5>
      
              <ul class="list-unstyled">
                <li>
                  <a href="#!">Link 1</a>
                </li>
                <li>
                  <a href="#!">Link 2</a>
                </li>
                <li>
                  <a href="#!">Link 3</a>
                </li>
                <li>
                  <a href="#!">Link 4</a>
                </li>
              </ul>
      
            </div>
            <!-- Grid column -->
      
          </div>
          <!-- Grid row -->
      
        </div>
        <!-- Footer Links -->
      
        <!-- Copyright -->
        <div class="footer-copyright text-center py-1">© 2021 Copyright:
          <a > Mustafa Ahmed Elshaer</a>
        </div>
        <!-- Copyright -->
      
      </footer>
</div>
  <!-- Footer -->
</div>